/* eslint-disable */
import type { RequestContext } from "../RequestContextProto.pb";
import type { ResponseContext } from "../ResponseContextProto.pb";

/** The request to confirm or decline a merge. */
export interface ResolveMergeRequest {
  request_context?: RequestContext;
  confirm_merge?: boolean;
}

export interface ResolveMergeResponse {
  response_context?: ResponseContext;
  status?: ResolveMergeResponseStatus;
}

export enum ResolveMergeResponseStatus {
  INVALID = "INVALID",
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}
